import { InjectionToken } from "@angular/core";

export const ASSET_ROOT_URL = new InjectionToken<string>("ASSET_ROOT_URL");
